import React, { useRef, useState } from 'react';
import { ChevronLeft, ChevronRight, Play, Pause } from 'lucide-react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './ui/carousel';

const VideoCarousel = ({ videos, posterImages, videoTitles, title, category }) => {
  const videoRefs = useRef([]);
  const [playingIndex, setPlayingIndex] = useState(null);

  const togglePlay = (index) => {
    const video = videoRefs.current[index];
    if (video) {
      if (video.paused) {
        video.play();
        setPlayingIndex(index);
      } else {
        video.pause();
        setPlayingIndex(null);
      }
    }
  };

  const handleVideoEnd = (index) => {
    setPlayingIndex(null);
  };

  return (
    <div className="group relative overflow-hidden">
      <Carousel className="w-full">
        <CarouselContent>
          {videos.map((video, index) => (
            <CarouselItem key={index}>
              <div className="aspect-[4/3] overflow-hidden bg-gray-900 relative">
                <video 
                  ref={el => videoRefs.current[index] = el}
                  src={video}
                  className="w-full h-full object-cover"
                  loop={false}
                  playsInline
                  preload="none"
                  controls
                  poster={posterImages && posterImages[index] ? posterImages[index] : undefined}
                  onLoadedData={(e) => {
                    // Only seek if no poster image is provided
                    if (!posterImages || !posterImages[index]) {
                      e.target.currentTime = 10.0;
                    }
                  }}
                  onEnded={() => handleVideoEnd(index)}
                />
                
                {/* Video Title in Top Right Corner */}
                {videoTitles && videoTitles[index] && (
                  <div className="absolute top-4 right-4 bg-black/80 px-4 py-2 border-l-2 border-gold max-w-xs">
                    <p className="text-white text-sm font-medium leading-tight">
                      {videoTitles[index]}
                    </p>
                  </div>
                )}
                
                {/* Play/Pause Button Overlay */}
                <button
                  onClick={() => togglePlay(index)}
                  className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/40 transition-all duration-300 group/play"
                >
                  {playingIndex === index ? (
                    <Pause className="w-16 h-16 text-white opacity-0 group-hover/play:opacity-100 transition-opacity duration-300" />
                  ) : (
                    <Play className="w-16 h-16 text-gold opacity-80 group-hover/play:opacity-100 transition-opacity duration-300" />
                  )}
                </button>
                
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300 pointer-events-none"></div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        
        {/* Custom Navigation Buttons */}
        <CarouselPrevious className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 border-gold hover:bg-gold hover:text-black transition-all duration-300 opacity-0 group-hover:opacity-100" />
        <CarouselNext className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 border-gold hover:bg-gold hover:text-black transition-all duration-300 opacity-0 group-hover:opacity-100" />
      </Carousel>
      
      {/* Project Info Overlay */}
      <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300 pointer-events-none">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-playfair text-2xl font-bold">{title}</h3>
          </div>
        </div>
      </div>
      
      {/* Video Counter */}
      <div className="absolute top-4 right-4 bg-black/70 px-3 py-1 text-xs text-gold border border-gold/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        {videos.length} VIDEOS
      </div>
    </div>
  );
};

export default VideoCarousel;
